 const varURL = window.location.href.split("=").pop();
 console.log(window.location);
      const varID = document.getElementsByClassName('hidvarid');
    function firstVarcolor () {
        for (let i = 0; i < varID.length; i++) {
            varID[0].parentElement.style.border = "2px solid #d52dba";
        };
        return;
    }
    function preselectDemo () {
      console.log(varURL);
      for (let i = 0; i < varID.length; i++) {
        if (varID[i].innerHTML == varURL) {
            varID[0].parentElement.style.border = "1px solid #ddd";
          varID[i].parentElement.style.border = "2px solid #d52dba";
          
        }
      }
      return;
    }
    firstVarcolor();
    preselectDemo();
    
      $(".allvar").on('click', function () {
        console.log("work");
        $(this).css("border","2px solid #d52dba");
        $(this).siblings().css("border","1px solid #ddd");
        const dum_var_txt = $(this).children(".all_var_txt").children(".allvar_p").text();
        var truevar = $(".truevar");
        for (let i = 0; i < truevar.length; i++) {
          if ($(truevar[i]).children(".truevarspan").text() == dum_var_txt) {
            $(truevar[i]).click();
          }
          
        }
      });